module.exports = __webpack_public_path__ + "static/media/telegram-gray.0629daee.svg";